var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Footer/TrusteSeals/TrustedShop.tsx",
  _this = this;
import React, { useEffect, useRef } from 'react';
var TrustedShop = function TrustedShop() {
  var trustedSpan = useRef(null);
  useEffect(function () {
    var tsID = 'X8F338485E616D91F6D5515EA0347B70B';
    var scriptSource = "//widgets.trustedshops.com/js/".concat(tsID, ".js");
    var script = document.createElement('script');
    var type = 'text/javascript';
    var charset = 'utf-8';
    script.type = type;
    script.charset = charset;
    script.src = scriptSource;
    var tsScript = document.getElementsByTagName('script')[0];
    if (!tsScript.parentNode) throw Error('Trusted Shop script does not exist!');
    tsScript.parentNode.insertBefore(script, tsScript);
    var tsConfigScript = document.createElement('script');
    tsConfigScript.type = type;
    tsConfigScript.innerHTML = "\n      (function () {\n        var _tsid = '".concat(tsID, "';\n        _tsConfig = {\n            'yOffset': '0', /* offset from page bottom */\n            'variant': 'custom', /* text, default, small, reviews, custom, custom_reviews */\n            'customElementId': 'TrustedShops', /* required for variants custom and custom_reviews */\n            'trustcardDirection': '', /* for custom variants: topRight, topLeft, bottomRight, bottomLeft */\n            'customBadgeWidth': '40', /* for custom variants: 40 - 90 (in pixels) */\n            'customBadgeHeight': '40', /* for custom variants: 40 - 90 (in pixels) */\n            'disableResponsive': 'false', /* deactivate responsive behaviour */\n            'disableTrustbadge': 'false', /* deactivate trustbadge */\n            'trustCardTrigger': 'mouseenter' /* set to 'click' if you want the trustcard to be opened on click instead */\n        };\n      })();");
    if (!trustedSpan.current) throw Error('trustedSpan is not assigned');
    trustedSpan.current.appendChild(tsConfigScript);
  }, []);
  return /*#__PURE__*/React.createElement("span", {
    id: "TrustedShops",
    "data-language": "en",
    ref: trustedSpan,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 10
    }
  });
};
export default TrustedShop;
//# sourceMappingURL=TrustedShop.js.map